import moment from 'moment'

/**
 * stringの時刻をフォーマットする関数
 * @param {string} dateTime フォーマット前の日付時刻
 */
type Arg = {
  dateTime: string
  language?: string
}
export const generateDate = ({ dateTime, language = 'en' }: Arg) => {
  const lang = ['en', 'ja'].includes(language) ? language : 'en'
  return moment(dateTime).format(
    lang === 'ja' ? 'YYYY年MM月DD日' : 'MMMM DD, YYYY',
  )
}
